export enum MaterialDisplayTypes {
  List,
  Deadline,
}
